import React from 'react';
import Button  from '../components/ui/Button';
import Input   from '../components/ui/Input';
import Icon    from '../components/ui/Icon';
import useForm from '../hooks/useForm';
import { useAuth } from '../context/AuthContext';
import useLogin    from '../hooks/useLogin';
import logo from '../assets/logo.png';

const validate = (v) => {
  const e = {};
  if (!v.email)                            e.email    = 'Email is required';
  else if (!/\S+@\S+\.\S+/.test(v.email)) e.email    = 'Enter a valid email';
  if (!v.password)                         e.password = 'Password is required';
  else if (v.password.length < 6)          e.password = 'Minimum 6 characters';
  return e;
};

const LoginPage = () => {
  const { goTo } = useAuth();
  const loginMutation = useLogin();

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useForm(
    { email: '', password: '' },
    validate,
  );

  const onSubmit = (vals) => {
    loginMutation.mutate({ email: vals.email, password: vals.password });
  };

  return (
    <div className="page-scroll flex flex-col min-h-full bg-surface-900 relative overflow-hidden">
      <div className="noise-overlay" />
      <div
        className="absolute -top-24 -right-24 w-64 h-64 rounded-full opacity-[0.08] pointer-events-none"
        style={{ background: 'radial-gradient(circle, #6366f1, transparent 70%)' }}
      />
      <div
        className="absolute bottom-0 -left-20 w-56 h-56 rounded-full opacity-[0.05] pointer-events-none"
        style={{ background: 'radial-gradient(circle, #6366f1, transparent 70%)' }}
      />

      {/* Hero */}
      <div className="px-6 pt-16 pb-8 animate-fadeUp" style={{ animationFillMode: 'forwards' }}>
        <div className="mb-8">
          <img src={logo} alt="HostAssist" className="w-16 h-16 object-contain" />
        </div>

        <p className="font-dm text-surface-200 text-sm mb-1 uppercase tracking-widest">Welcome back</p>
        <h1 className="font-syne font-extrabold text-slate-800 text-[2rem] leading-tight">
          Sign in to<br />
          <span className="text-gradient">HostAssist</span>
        </h1>
        <p className="font-dm text-surface-200 text-sm mt-3">
          On-demand home services at your fingertips.
        </p>
      </div>

      {/* Form card */}
      <div className="flex-1 px-5 pb-8">
        <div className="glass rounded-3xl p-6 card-shadow animate-fadeUp s2" style={{ animationFillMode: 'forwards' }}>
          <div className="flex flex-col gap-4">
            <Input
              label="Email Address" name="email" type="email" placeholder="you@email.com"
              value={values.email} onChange={handleChange} onBlur={handleBlur}
              error={touched.email && errors.email} icon="mail" autoComplete="email"
            />
            <Input
              label="Password" name="password" type="password" placeholder="••••••••"
              value={values.password} onChange={handleChange} onBlur={handleBlur}
              error={touched.password && errors.password} icon="lock" autoComplete="current-password"
            />

            <div className="text-right">
              <button className="font-dm text-xs text-brand-600 hover:text-brand-500 transition-colors">
                Forgot password?
              </button>
            </div>

            <Button
              size="lg"
              loading={loginMutation.isPending}
              onClick={() => handleSubmit(onSubmit)}
            >
              <Icon name="arrow" size={16} />
              Sign In
            </Button>
          </div>
        </div>

        <p className="text-center font-dm text-sm text-surface-200 mt-6 animate-fadeUp s4" style={{ animationFillMode: 'forwards' }}>
          Don't have an account?{' '}
          <button onClick={() => goTo('register')} className="text-brand-600 font-semibold hover:text-brand-500 transition-colors">
            Create one
          </button>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
